import OurInvester from "../components/v2/our-invester";
import {MwSmallIcon} from "../components/v2/icons";
import Card from "../components/v2/cards/card";
import OurCareerCTA from "../components/v2/our-career";
import Carousel from "react-multi-carousel";
import AboutUsGallery from "../components/v2/about-us-gallery";
import { useTranslation } from "next-i18next";
import "../styles/scss/about-us.module.scss";
import "../styles/scss/solutions.module.scss";

export default function AboutUs() {
    const { t } = useTranslation('common');
    const aboutUsData = t('aboutUs', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = aboutUsData?.hero || {};
    const weFoundData = aboutUsData?.weFound || {};
    const missionData = aboutUsData?.mission || {};
    const commitmentsData = aboutUsData?.commitments || {};
    
    const carouselItems = Array.isArray(heroData?.carouselItems) ? heroData.carouselItems : [];
    const technologyCards = Array.isArray(commitmentsData?.cards) ? commitmentsData.cards : [];

    const imageSets = [
        ["/images/about-us/gallery/garden-view.webp", "/images/about-us/gallery/mw-team-beach.webp"],
        ["/images/about-us/gallery/swimming.webp", "/images/about-us/gallery/room-view.webp"],
        ["/images/about-us/gallery/mw-girl-team.webp", "/images/about-us/gallery/mw-discuss-2.png"],
        ["/images/about-us/gallery/lead-discuss-1.png", "/images/about-us/gallery/cycling-fun.webp"],
        ["/images/about-us/gallery/mw-funny.webp", "/images/about-us/gallery/lunch-time.webp"]
    ];

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    return (
        <div className="middle-wrapper site-page about-us solutions">
            <div className={"container"}>
                <div className={"about-hero"}>
                    <div className={"d-flex"}>
                        <div className={"left-block"}>
                            <h1>{String(heroData?.titlePrefix ?? '')}</h1>
                            <Carousel responsive={responsive} infinite={true} autoPlay={true} arrows={false}>
                                {carouselItems.map((item, index) => (
                                    <div key={index}>
                                        <h1 className={"text-gradient"}>{String(item)}</h1>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                        <div className={"right-block"}>
                            <p>{String(heroData?.description ?? '')}</p>
                        </div>
                    </div>
                </div>

                <div className={"image-slideshow"}>
                   <AboutUsGallery imageSets={imageSets}/>
                </div>

                <div className={"we-found"}>
                    <div className={"d-flex"}>
                        <div className={"found"}>
                            <p>{String(weFoundData?.found?.label ?? '')}</p>
                            <h4>{String(weFoundData?.found?.year ?? '')}</h4>
                        </div>
                        <div className={"office"}>
                            <p>{String(weFoundData?.offices?.label ?? '')}</p>
                            <h4 dangerouslySetInnerHTML={{ __html: String(weFoundData?.offices?.locations ?? '') }}></h4>
                        </div>
                        <div className={"build-by"}>
                            <h5>{String(weFoundData?.buildBy?.title ?? '')}</h5>
                            <p>{String(weFoundData?.buildBy?.description ?? '')}</p>
                        </div>
                    </div>
                </div>

                <OurInvester/>

            </div>
            <div className={"our-mission"}>
                <div className={"container"}>
                    <div className={"d-flex"}>
                        <div className={"left-block"}>
                            <div className={'section-tag testimonial'}><MwSmallIcon/> {String(missionData?.sectionTag ?? '')}</div>
                            <h2>
                                {String(missionData?.titlePrefix ?? '')}
                                <span className={"text-gradient"}> {String(missionData?.titleHighlight ?? '')} </span>
                                {String(missionData?.titleMiddle ?? '')}
                                <span className={"text-gradient"}> {String(missionData?.titleHighlight2 ?? '')} </span>
                            </h2>
                        </div>
                        <div className={"right-block"}>
                            <div className={"right-card"}>
                                {Array.isArray(missionData?.description) ? missionData.description.map((paragraph, index) => (
                                    <p key={index}>{String(paragraph)}</p>
                                )) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*<OurLeader/>*/}

            <section className={'mw-card'}>
                <div className={'container'}>
                    <div className={'d-flex card-items'}>
                        <div className={'card-item'}>
                            <div className={'section-tag testimonial pd-right'}><MwSmallIcon/>{String(commitmentsData?.sectionTag ?? '')}</div>
                            <h2>
                                {String(commitmentsData?.titlePrefix ?? '')}
                                <span className={"text-gradient"}> {String(commitmentsData?.titleHighlight ?? '')} </span>
                            </h2>
                        </div>
                        {
                            technologyCards.map((item, index) => {
                                // Explicitly convert to boolean, defaulting to false if undefined
                                const isHeadingValue = item?.isHeading === true;
                                return <Card key={index}
                                             heading={String(item.heading ?? '')}
                                             description={String(item.description ?? '')}
                                             isHeading={isHeadingValue}
                                             title={isHeadingValue ? undefined : ""}/>
                            })
                        }
                    </div>
                </div>
            </section>
            <OurCareerCTA/>
        </div>
    )
}
